import {inject} from "@angular/core";
import {
    ActivatedRouteSnapshot,
    CanActivateFn,
    GuardResult,
    MaybeAsync,
    Router,
    RouterStateSnapshot
} from "@angular/router";
import {AuthStore, authStore} from "../service/auth/auth.store";

export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> => {
    const auth: AuthStore = inject(authStore);
    const router = inject(Router);

    return auth.isAuthenticated()
        ? true
        : router.parseUrl('/login');
}

